export const getMobileIframeDocument = (): Document | null => {
    const iframe = document.getElementById("mobileView") as HTMLIFrameElement | null;
    return iframe?.contentDocument ?? null;
};

export const getAdultVerificationDocuments = (): Document[] => {
    const documents: Document[] = [document];
    const iframeDocument = getMobileIframeDocument();

    if (iframeDocument && !documents.includes(iframeDocument)) {
        documents.push(iframeDocument);
    }

    return documents;
};
